import React, { useEffect, useRef, useState } from 'react'
import './item-history.styles.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DetailedActivityList from '@/components/SHARED/detailed-activity-list/detailed-activity-list.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { getGameActivityFromDb } from '@/utils/getDataFromDb';
import DetailedActivityListTable from '@/components/SHARED/detailed-activity-list/detailed-activity-list-table.component';
import PlayerEarningsList from '../player-blocks/components/status-elements/player-earnings-list.component';

const ItemHistory = ({ 
    gameData,
    playerData, 
    playerActivity,
    playerList, 
    gameElements 
}) => {

    const [ activityToDisplay, setActivityToDisplay ] = useState([]); 
    const [ elementToDisplay, setElementToDisplay ] = useState(null);
    const { itemPath } = useParams();
    const navigate = useNavigate();
    const location= useLocation();
    const activityRef = useRef();

    useEffect(() => {
        if (!itemPath || !gameElements || !playerData) return;
        const itemData = Object.values(gameElements).filter(e => e.path === itemPath)[0];
        setElementToDisplay({...itemData});
        console.log(itemData);
        // getItemHistory(itemData);
        // const activity = Object.values(playerActivity)

    }, [itemPath, gameElements, playerData])

    // function getItemHistory(itemData) {
    //     getGameActivityFromDb({
    //         "gameId": gameData.gameId,
    //         "playerId": playerData.playerId,
    //         "elementId": itemData.id,
    //         "once": true,
    //         "callback": callback,
    //     })
    //     function callback(data) {
    //         console.log(data);
    //         activityRef.current = {
    //             ...activityRef.current,
    //             ...data
    //         }
    //         setActivityToDisplay(Object.values(activityRef.current));
    //     }
    // }

    return (
        <div className='item-history'>
            {
                (elementToDisplay) &&
                <div className='g-card item-history-card'>
                    <BackButton cancel={() => navigate(-1)} />
                    <div className='g-space-1'></div>
                    <div className='card-title'>
                        <ImageContainer src={elementToDisplay.icon} className='head-icon' />
                        {elementToDisplay.name} | Item History
                    </div>
                    <hr />
                    {
                        (gameData && playerData && gameElements && elementToDisplay)
                        ?
                        // <DetailedActivityListTable 
                        //     gameData={gameData}
                        //     playerData={playerData}
                        //     activityToDisplay={activityToDisplay}
                        //     hidePlayer={true}  
                        //     playerList={{
                        //         [playerData.playerId]: playerData
                        //     }}
                        //     gameElements={gameElements}
                        //     manager={
                        //         location.pathname.includes('/manage/') ? true : false
                        //     }
                        // />
                        <PlayerEarningsList
                            gameData={gameData}
                            playerData={playerData}
                            gameElements={gameElements}
                            type={elementToDisplay.id}
                            noPurchases={false}
                        />
                        :
                        <div className='center-col'>
                            <h4>No history to view</h4>
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default ItemHistory